export function formatXOF(v) {
  const n = Number(v || 0);
  return new Intl.NumberFormat("fr-FR", {
    style: "decimal",
    maximumFractionDigits: 0,
  }).format(n) + " FCFA";
}

export function formatNumber(v, digits = 0) {
  return new Intl.NumberFormat("fr-FR", { maximumFractionDigits: digits }).format(Number(v || 0));
}

export function formatDate(iso) {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    return d.toLocaleDateString("fr-FR", { day: "2-digit", month: "short", year: "numeric" });
  } catch {
    return iso;
  }
}

export function formatDateTime(iso) {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    return d.toLocaleString("fr-FR", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
  } catch {
    return iso;
  }
}

export const ROLE_LABELS = {
  super_admin: "Super administrateur",
  owner: "Promoteur",
  admin: "Administrateur d'école",
  director: "Directeur général",
  study_director: "Directeur des études",
  secretary: "Secrétaire",
  accountant: "Comptable",
  cashier: "Caissier",
  hr: "Ressources humaines",
  teacher: "Enseignant",
  supervisor: "Surveillant",
  librarian: "Bibliothécaire",
  stock_manager: "Gestion de stock",
  parent: "Parent / Tuteur",
  student: "Élève",
  auditor: "Auditeur",
};

export const METHOD_LABELS = {
  cash: "Espèces",
  orange_money: "Orange Money",
  moov_money: "Moov Money",
  wave: "Wave",
  bank: "Virement bancaire",
  check: "Chèque",
  card: "Carte bancaire",
};

export const METHOD_COLORS = {
  cash: "bg-emerald-100 text-emerald-800 dark:bg-emerald-950 dark:text-emerald-200",
  orange_money: "bg-orange-100 text-orange-800 dark:bg-orange-950 dark:text-orange-200",
  moov_money: "bg-blue-100 text-blue-800 dark:bg-blue-950 dark:text-blue-200",
  wave: "bg-sky-100 text-sky-800 dark:bg-sky-950 dark:text-sky-200",
  bank: "bg-slate-100 text-slate-800 dark:bg-slate-800 dark:text-slate-200",
  check: "bg-slate-100 text-slate-800 dark:bg-slate-800 dark:text-slate-200",
  card: "bg-purple-100 text-purple-800 dark:bg-purple-950 dark:text-purple-200",
};
